/* eslint-disable no-unused-vars */
import { ReactNode } from "react";
import parse from "html-react-parser";
import { commonHtmlParserOptions } from "@utils/html-parser";
import { twMerge } from "tailwind-merge";
import classNames from "classnames";
import AngleUpIcon from "@svg/angle-up";

interface AccordionProps {
  title: string | ReactNode;
  hasResult?: boolean;
  className?: ((isOpen?: boolean) => string) | string;
  titleClassName?: ((isOpen?: boolean) => string) | string;
  contentClassName?: ((isOpen?: boolean) => string) | string;
  iconComponent?: (isOpen?: boolean) => React.ReactNode;
  titleIsHtml?: boolean;
  isOpen: boolean;
  onClick: () => void;
  children?: ReactNode;
}

const ControlledAccordion: React.FC<AccordionProps> = ({
  titleIsHtml,
  title,
  isOpen,
  onClick,
  children,
  className = "",
  titleClassName = "",
  contentClassName = "",
  iconComponent,
}) => {
  const renderIconComponent = iconComponent ? (
    iconComponent(isOpen)
  ) : (
    <AngleUpIcon
      width={16}
      height={16}
      className={classNames(
        "mr-2.5 transition-transform duration-300 ease-linear",
        { "rotate-180": !isOpen }
      )}
    />
  );
  const wrapperClassNames =
    typeof className === "string" ? className : className(isOpen);
  const titleClassNames =
    typeof titleClassName === "string"
      ? titleClassName
      : titleClassName(isOpen);
  const contentClassNames =
    typeof contentClassName === "string"
      ? contentClassName
      : contentClassName(isOpen);

  return (
    <div className="w-full">
      <div
        onClick={onClick}
        className={twMerge(
          "flex justify-between items-center box-border cursor-pointer h-[59px]",
          wrapperClassNames
        )}
      >
        <div
          className={twMerge(
            "font-bold flex-shrink overflow-auto break-words",
            titleClassNames
          )}
        >
          {titleIsHtml && typeof title === "string"
            ? parse(title || "", commonHtmlParserOptions())
            : title}
        </div>
        {renderIconComponent}
      </div>
      <div
        className={twMerge(
          "grid transition-[grid-template-rows] duration-300 ease-linear",
          isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]",
          contentClassNames
        )}
      >
        <div className="min-h-0 overflow-hidden">
          <div className="w-full flex flex-col">{isOpen && children}</div>
        </div>
      </div>
    </div>
  );
};

export default ControlledAccordion;
